var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({tag:"component",class:[_vm.linkClass, _vm.customClasses]},_vm.$listeners),[_c('span',{staticClass:"link__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }